// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-OycVeA0V","ad_1":"ad_1-2VK745e0","ad_2":"ad_2-DDtJRdK4"};